<template>
    <div>
        <el-tabs tab-position="top" style="height: 200px;padding: 20px;">
            <el-tab-pane label="个人中心" class="person-center">
                <div class="person-body">
                    <el-form ref="form" :model="userInfo" label-width="80px">
                        <el-form-item label="用户名">
                            <el-input v-model="userInfo.name"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input v-model="userInfo.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="原密码">
                            <el-input v-model="userInfo.oldPassword"></el-input>
                        </el-form-item>
                        <el-form-item label="新密码">
                            <el-input v-model="userInfo.password"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="updateUserInfoClick">确认修改</el-button>
                            <!-- <el-button type="warning" @click="resetPasswordClick(userInfo.id)">密码重置</el-button> -->
                            <!-- <el-button type="danger" @click="updatePasswordClick">密码修改</el-button> -->
                        </el-form-item>
                    </el-form>
                </div>
            </el-tab-pane>
            <el-tab-pane label="账户中心" class="admin-center" v-if="isSuperAdmin">
                <div class="admin-body">
                    <el-form ref="form" :model="tableParams" label-width="80px" :inline="true">
                        <el-form-item label="用户名">
                            <el-input v-model="tableParams.name" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input v-model="tableParams.phone" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="queryUsersClick">查询</el-button>
                            <el-button @click="resetParamsClick">重置</el-button>
                            <el-button type="primary" @click="insertUserClick">新增</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table
                        :data="tableData.list"
                        stripe
                        style="width: 100%">
                        <el-table-column
                            prop="name"
                            label="账号"
                            width="180">
                        </el-table-column>
                        <!-- <el-table-column
                            prop="password"
                            label="密码"
                            width="180">
                        </el-table-column> -->
                        <el-table-column
                            prop="phone"
                            label="手机号"
                            width="180">
                        </el-table-column>
                        <el-table-column
                            prop="status"
                            label="状态"
                            width="180">
                            <template slot-scope="scope">
                                <el-switch
                                    v-model="scope.row.statusFlag"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    @change="updateUserStatus(scope.row)">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作">
                            <template slot-scope="scope">
                                <el-button @click="editUserInfoClick(scope.row)" type="primary" size="small">编辑</el-button>
                                <el-button @click="resetPasswordClick(scope.row.id)" type="warn" size="small">密码重置</el-button>
                                <el-button @click="deleteUserClick(scope.row)" type="danger" size="small">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="form-pagination">
                        <el-pagination
                            :current-page="tableData.pageNum"
                            :page-size="tableData.pageSize"
                            layout="total, prev, pager, next"
                            :total="tableData.total"
                            @prev-click="changePage(1)"
                            @next-click="changePage(-1)"
                            @current-change="handleCurrentChange">
                        </el-pagination>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>

        <el-dialog :title="dialogUserInfo.newUpdateUserTitle" :visible.sync="dialogUserInfo.newUpdateUserVisible" width="30%">
            <div class="dialog-person-body">
                    <el-form ref="form" :model="dialogUserInfo.userInfo" label-width="80px">
                        <el-form-item label="用户名">
                            <el-input v-model="dialogUserInfo.name"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input v-model="dialogUserInfo.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-switch
                                v-model="dialogUserInfo.statusFlag"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                @change="toggleUserStatus(dialogUserInfo.statusFlag)">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="默认密码" v-if="!dialogUserInfo.id">
                            <el-input v-model="dialogUserInfo.password" disabled></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="newUpdateUserClick">确认修改</el-button>
                            <!-- <el-button type="warning" @click="resetPasswordClick(userInfo.id)">密码重置</el-button> -->
                            <!-- <el-button type="danger" @click="updatePasswordClick">密码修改</el-button> -->
                        </el-form-item>
                    </el-form>
                </div>
        </el-dialog>
    </div>
</template>

<script>
import NProgress from 'nprogress'
import { 
    getAdminUserByIdApi, updateAdminUserPasswordApi, getAdminUserByPageApi, resetPasswordByAdminUserIdApi, 
    addNewAdminUserApi, updateAdminUserByIdApi, deleteAdminUserByIdApi
} from '../../api/api';

    export default {
        data() {
            return {
                userInfo:{
                    id:'',
                    name:'',
                    phone:'',
                    oldPassword:'',
                    password:'',
                },
                tableParams: {
                    name: '',
                    phone: '',
                    pageNum: 1,
                    pageSize: 10,
                },
                tableData: {
                    list: [
                    ],
                    pageNum: 1,
                    pageSize: 10,
                    total: 0,
                },
                dialogUserInfo: {
                    newUpdateUserTitle: '',
                    newUpdateUserVisible: false,
                    id: '',
                    name: '',
                    phone: '',
                    status: 1,
                    statusFlag: true,
                    password: 123456
                }
            }
        },
        computed: {
            isSuperAdmin(){
                var user = sessionStorage.getItem('user');
                if (user) {
                    user = JSON.parse(user);
                    return user.adminType == 1
                } else {
                    return false
                }
            }
        },
        methods: {
            initAdminUserInfo(){
                NProgress.start();
                let user = eval('(' + sessionStorage.getItem('user') + ')');
                let params = {id: user.id}
                getAdminUserByIdApi(params).then(data => {
                    NProgress.done();
                    let { status, result } = data;
                    this.userInfo = Object.assign(new Object(), result)
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            updateUserInfoClick(){
                let params = this.userInfo
                updateAdminUserPasswordApi(params).then(data => {
                    NProgress.done();
                    let { status, result } = data;
                    if (result) {
                        this.$message.success("更新成功");
                        // 刷新用户缓存信息
                        getAdminUserByIdApi(params).then(data => {
                            NProgress.done();
                            let { status, result } = data;
                            this.userInfo = Object.assign(new Object(), result)
                            sessionStorage.removeItem('user')
                            sessionStorage.setItem('user', JSON.stringify(result));
                            window.location.reload()
                        }).catch(error => {
                            this.$message.error(error.message);
                            NProgress.done();
                        });
                    } else {
                        this.$message.error("更新失败");
                    }
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            queryUsersClick(){
                NProgress.start();
                getAdminUserByPageApi(this.tableParams).then(data => {
                    NProgress.done();
                    let { status, result } = data;
                    this.tableData = result
                    this.tableData.total = Number.parseInt(this.tableData.total)
                    this.tableData.list.forEach(e => {
                        e.statusFlag = e.status == 1
                    });
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            resetParamsClick(){
                this.tableParams = {
                    name: '',
                    phone: '',
                    pageNum: 1,
                    pageSize: 10,
                }
            },
            insertUserClick(){
                this.dialogUserInfo = {
                    newUpdateUserTitle: '新增用户',
                    newUpdateUserVisible: true,
                    id: '',
                    name: '',
                    phone: '',
                    status: 1,
                    statusFlag: true,
                    password: 123456
                }
            },
            toggleUserStatus(statusFlag){
                if (statusFlag) {
                    this.dialogUserInfo.status = 1
                } else {
                    this.dialogUserInfo.status = 0
                }
            },
            newUpdateUserClick(){
                NProgress.start()
                let params = this.dialogUserInfo
                if (this.dialogUserInfo.id) {
                    // 更新用户
                    updateAdminUserByIdApi(params).then(data => {
                        NProgress.done();
                        let { status, result } = data;
                        if (result) {
                            this.$message.success("更新成功");
                            this.queryUsersClick()
                        } else {
                            this.$message.error("更新失败");
                        }
                    }).catch(error => {
                        this.$message.error(error.message);
                        NProgress.done();
                    });
                } else {
                    // 新增用户
                    addNewAdminUserApi(params).then(data => {
                        NProgress.done();
                        let { status, result } = data;
                        if (result) {
                            this.$message.success("新增成功");
                            this.queryUsersClick()
                        } else {
                            this.$message.error("新增失败");
                        }
                    }).catch(error => {
                        this.$message.error(error.message);
                        NProgress.done();
                    });
                }
            },
            changePage(num){
                if (this.tableParams + num < 1) {
                    return
                }
                this.queryUsersClick()
            },
            handleCurrentChange(pageNum){
                this.tableParams.pageNum = pageNum
                this.queryUsersClick()
            },
            updateUserStatus(user){
                user.status = user.statusFlag ? 1 : 0
                updateAdminUserByIdApi(user).then(data => {
                    NProgress.done();
                    let { status, result } = data;
                    if (result) {
                        this.$message.success("更新成功");
                        this.queryUsersClick()
                    } else {
                        this.$message.error("更新失败");
                    }
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            resetPasswordClick(userId){
                let params = {id: userId}
                resetPasswordByAdminUserIdApi(params).then(data => {
                    NProgress.done();
                    let { status, result } = data;
                    if (result) {
                        this.$message.success("更新成功");
                    } else {
                        this.$message.error("更新失败");
                    }
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            editUserInfoClick(user){
                this.dialogUserInfo = {
                    newUpdateUserTitle: '更新用户信息',
                    newUpdateUserVisible: true,
                    id: user.id,
                    name: user.name,
                    phone: user.phone,
                    status: user.status,
                    statusFlag: user.status == 1,
                    password: ''
                }
            },
            deleteUserClick(user){
                deleteAdminUserByIdApi(user).then(data => {
                    NProgress.done();
                    let { status, result } = data;
                    this.$message.success("删除成功");
                    this.queryUsersClick()
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
        },
        mounted() {
            this.initAdminUserInfo();
            this.queryUsersClick();
        }
    }

</script>

<style scoped lang="scss">
    .person-center{
        padding: 20px;
        display: flex;
        justify-content: center;
        .person-body{
            // border: 1px solid blue;
            margin-top: 100px;
            width: 500px;
        }
    }
    .admin-center{
        padding: 20px;
        .admin-body{
            // border: 1px solid blue;
            width: 100%;
            height: 700px;
        }
    }
</style>


// WEBPACK FOOTER //
// admin.vue?318f638a